import styled from "styled-components"
import { motion } from "framer-motion"

export const HomeFeaturedSection = styled(motion.div)``

export const FeaturedContent = styled.div``
export const FeaturedVideo = styled.div``
export const FeaturedProjects = styled.div``
